"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldRetryRequest = exports.shouldRevalidateInstance = exports.backoffDelay = exports.isRetryableError = exports.isNetworkError = exports.isIdempotentMethod = exports.RETRY_CONFIG_DEFAULT = void 0;
const appError_1 = require("@wix/cashier-common/dist/src/utils/appError");
const REVALIDATE_STATUSES = [401, 403];
const RETRY_STATUS_RANGES = [
    [429, 429],
    [500, 599],
];
const IDEMPOTENT_HTTP_METHODS = ['get', 'head', 'options', 'put', 'delete'];
// taken from https://github.com/sindresorhus/is-retry-allowed
const RETRY_ERROR_CODES = [
    'ECONNABORTED', // axios sets ECONNABORTED instead of ETIMEDOUT
    'ETIMEDOUT',
    'ECONNRESET',
    'EADDRINUSE',
    'ESOCKETTIMEDOUT',
    'ECONNREFUSED',
    'EPIPE',
    'EHOSTUNREACH',
    'EAI_AGAIN',
];
exports.RETRY_CONFIG_DEFAULT = {
    maxRetry: 2,
    maxRevalidate: 1,
    retryAttempt: 0,
    revalidateAttempt: 0,
    delay: 100,
};
const isIdempotentMethod = (method) => {
    return method && IDEMPOTENT_HTTP_METHODS.includes(method);
};
exports.isIdempotentMethod = isIdempotentMethod;
const isNetworkError = (error) => {
    return (!error.response && (error.message === 'Network Error' || (!!error.code && RETRY_ERROR_CODES.includes(error.code))));
};
exports.isNetworkError = isNetworkError;
const isRetryableError = (error) => {
    var _a;
    if ((0, exports.isNetworkError)(error)) {
        return true;
    }
    const status = (_a = error.response) === null || _a === void 0 ? void 0 : _a.status;
    if (!status) {
        return false;
    }
    return RETRY_STATUS_RANGES.some(([min, max]) => status >= min && status <= max);
};
exports.isRetryableError = isRetryableError;
const backoffDelay = (config, isExponential = false) => {
    let delay = config.retryConfig.delay;
    if (isExponential) {
        // formula: (2^c - 1 / 2) * 1000
        delay = ((Math.pow(2, config.retryConfig.retryAttempt) - 1) / 2) * 1000;
    }
    delay = delay + delay * 0.2 * Math.random(); // randomization prevents several calls to happen at the same time
    return new Promise((resolve) => {
        setTimeout(resolve, delay);
    });
};
exports.backoffDelay = backoffDelay;
const shouldRevalidateInstance = (error) => !!(error === null || error === void 0 ? void 0 : error.response) &&
    typeof error.response.status === 'number' &&
    REVALIDATE_STATUSES.includes(error.response.status) &&
    !(0, appError_1.isCaptchaError)(error);
exports.shouldRevalidateInstance = shouldRevalidateInstance;
const shouldRetryRequest = (error) => {
    return (0, exports.isIdempotentMethod)(error.config.method) && (0, exports.isRetryableError)(error);
};
exports.shouldRetryRequest = shouldRetryRequest;
//# sourceMappingURL=retryUtils.js.map